/**
 * Checks for duplicate barcodes in a list of items
 * @param {Array} items - Array of items to check against
 * @param {Array} barcodesToCheck - Array of barcodes to check
 * @param {string|null} excludeProductId - Product ID to exclude from check (for edit mode)
 * @returns {Array} Array of items that have duplicate barcodes
 */
export const checkDuplicateBarcodes = (
  items,
  barcodesToCheck,
  excludeProductId = null
) => {
  if (!items || !Array.isArray(items) || items.length === 0) {
    return [];
  }

  if (
    !barcodesToCheck ||
    !Array.isArray(barcodesToCheck) ||
    barcodesToCheck.length === 0
  ) {
    return [];
  }

  const duplicateItems = [];
  const barcodesSet = new Set(
    barcodesToCheck.map((b) => String(b).trim()).filter((b) => b)
  );

  items.forEach((item) => {
    // Skip the current item if editing
    if (
      excludeProductId &&
      (item._id === excludeProductId || item.id === excludeProductId)
    ) {
      return;
    }

    // Get barcodes from item - handle different data structures
    let itemBarcodes = [];
    if (item.barcodeNumbers && Array.isArray(item.barcodeNumbers)) {
      itemBarcodes = item.barcodeNumbers;
    } else if (
      item.inventoryInfo?.barcodeNumber &&
      Array.isArray(item.inventoryInfo.barcodeNumber)
    ) {
      itemBarcodes = item.inventoryInfo.barcodeNumber;
    } else if (item.barcodeNumber && Array.isArray(item.barcodeNumber)) {
      itemBarcodes = item.barcodeNumber;
    }

    // Find which barcodes match
    const matchingBarcodes = itemBarcodes
      .map((barcode) => String(barcode).trim())
      .filter((barcode) => barcode && barcodesSet.has(barcode));

    if (matchingBarcodes.length > 0) {
      duplicateItems.push({
        _id: item._id || item.id,
        name: item.name || 'Unnamed Item',
        price: item.price || 0,
        image: item.image || null,
        duplicateBarcodes: matchingBarcodes,
      });
    }
  });

  return duplicateItems;
};
